import React, {Component} from 'react';

var classNames = require('classnames');
import {
    ElectricBoiler,
    Tank,
    WoodFiredBoiler,
    Pump,
    SV,
    AV,
    EB22,
    HeatExchanger,
    Element1,
    Element2,
    Element3,
    Element4,
    Element5,
    Cell,
    Uso,
    ElMeterCell,
    Progress
}
    from '../entries'
import {WithModal} from '../';
import * as trends from '../../trends.js';
import styles from './style.css';


const cellData = [
    {
        ps: ['ti_6_96_14'],
        chartPs: trends.teplo_t1,
        div_id: styles.Cell1,
        caption: "∆T °C",
        hint: "Дельта Ттон (разница температур между подачей и обраткой)"
    },
    {
        ps: ['ti_6_96_5'],
        chartPs: trends.teplo_t1,
        div_id: styles.Cell2,
        caption: "T °C",
        hint: "Т5 - температура подачи с теплообменника на нагрузки"
    },
    {
        ps: ['ti_6_96_9'],
        chartPs: trends.teplo_t1,
        div_id: styles.Cell3,
        caption: "T °C",
        hint: "Т9 - температура на теплообменник с нагрузки"
    },
    {
        ps: ['ti_6_96_13'],
        chartPs: trends.teplo_t2,
        div_id: styles.Cell4,
        caption: "∆T °C",
        hint: "Дельта Ттог (разница температур между подачей и обраткой теплообменника)"
    },
    {
        ps: ['ti_6_96_6'],
        chartPs: trends.teplo_t2,
        div_id: styles.Cell5,
        caption: "T °C",
        hint: "Т6 - температура обратки с теплообменника на генератор"
    },
    {
        ps: ['ti_6_96_3'],
        chartPs: trends.teplo_t2,
        div_id: styles.Cell6,
        caption: "T °C",
        hint: "Т3 - температура подачи на теплообменник от генератора"
    },
    {
        ps: ['ti_6_96_21'],
        chartPs: trends.teplo_t2,
        div_id: styles.Cell7,
        caption: "T °C",
        hint: "1Тз - Задание температуры перехода на теплоцентраль",
        className: styles.red
    },
    {
        ps: ['ti_6_96_4'],
        chartPs: trends.teplo_t3,
        div_id: styles.Cell8,
        caption: "T °C",
        hint: "Т4 -температура в баке аккумуляторе"
    },
    {
        ps: ['ti_6_96_22'],
        chartPs: trends.teplo_t3,
        div_id: styles.Cell9,
        caption: "T °C",
        hint: "2Тз - Задание минимальной температуры в баке аккумуляторе",
        className: styles.red
    },
    {
        ps: ['ti_6_94_9'],
        chartPs: trends.teplo_t4,
        div_id: styles.Cell10,
        caption: "T °C",
        hint: "2Тп - температура подачи с котла"
    },
    {
        ps: ['ti_6_96_12'],
        chartPs: trends.teplo_t4,
        div_id: styles.Cell11,
        caption: "∆T °C",
        hint: "Дельта Тэк (разница температур между подачей и обраткой котла)"
    },
    {
        ps: ['ti_6_94_10'],
        chartPs: trends.teplo_t4,
        div_id: styles.Cell12,
        caption: "T °C",
        hint: "2То - температура обратки на котел"
    },
    {
        ps: ['ti_6_96_2'],
        chartPs: trends.teplo_t5,
        div_id: styles.Cell13,
        caption: "T °C",
        hint: "Т2- температура подачи на нагрузку"
    },
    {
        ps: ['ti_6_96_23'],
        chartPs: trends.teplo_t5,
        div_id: styles.Cell14,
        caption: "T °C",
        hint: "ЗТз - Задание температуры подачи на нагрузку",
        className: styles.red
    },
    {
        ps: ['ti_6_94_7'],
        chartPs: trends.teplo_t6,
        div_id: styles.Cell15,
        caption: "T °C",
        hint: "1Тп - температура на нагрузку"
    },
    {
        ps: ['ti_6_94_8'],
        chartPs: trends.teplo_t6,
        div_id: styles.Cell16,
        caption: "T °C",
        hint: "1То - температура с нагрузки"
    },
    {
        ps: ['ti_6_96_15'],
        chartPs: trends.teplo_t6,
        div_id: styles.Cell17,
        caption: "∆T °C",
        hint: "Дельта Тн (разница температур между подачей и обраткой)"
    },
    {
        ps: ['ti_6_96_1'],
        chartPs: trends.teplo_t7,
        div_id: styles.Cell18,
        caption: "T °C",
        hint: "Т1 - температура наружного воздуха"
    },
    {
        ps: ['ti_6_96_8'],
        chartPs: trends.teplo_t8,
        div_id: styles.Cell19,
        caption: "T °C",
        hint: "Т8 - температура воздуха в отделе заказов"
    },
    {
        ps: ['ti_6_96_7'],
        chartPs: trends.teplo_t9,
        div_id: styles.Cell20,
        caption: "T °C",
        hint: "Т7 - темепература воздуха в ИТП"
    }
];

export default class Teplo extends WithModal {

    render() {
        return (
            <div className={[this.props.className, styles.App, "row col-md-12"].join(' ')}>
                <div className={styles.canvases}>
                    <ElectricBoiler {...this.props} ps={['tc_6_112_400', 'tc_6_112_3']} canvas_id={styles.canvas1}/>
                    <ElectricBoiler {...this.props} ps={['tc_6_118_400', 'tc_6_118_3']} canvas_id={styles.canvas2}/> 
                    <WoodFiredBoiler {...this.props} ps={['tc_6_127_102']} div_id={styles.canvas34}/>                   
                    <ElectricBoiler {...this.props} ps={['tc_6_115_400', 'tc_6_115_3']} canvas_id={styles.canvas13}/>
                    <Pump {...this.props} ps={['tc_6_115_4', 'tc_6_115_16']} div_id={styles.canvas3}/>
                    <Pump {...this.props} ps={['tc_6_97_11', 'tc_6_96_135']} div_id={styles.canvas14}/>
                    <Pump {...this.props} ps={['tc_6_97_12', 'tc_6_96_136']} div_id={styles.canvas15}/>
                    <SV {...this.props} ps={['tc_6_96_109']} canvas_id={styles.canvas4}/>
                    <AV {...this.props} canvas_id={styles.canvas5}/>
                    <Tank {...this.props} ps={['ti_6_96_65', 'tc_6_96_110']} div_id={styles.canvas6}
                          canvas_id="Random1489"/>
                    <Element2 {...this.props} canvas_id={styles.canvas7}/>
                    <Element2 {...this.props} canvas_id={styles.canvas17}/>
                    <HeatExchanger {...this.props} canvas_id={styles.canvas8}/>
                    <Element4 {...this.props} canvas_id={styles.canvas9}/>
                    <Element1 {...this.props} canvas_id={styles.canvas16}/>
                    <Element5 {...this.props} canvas_id={styles.canvas12}/>
                    <Progress {...this.props} ps={['ti_6_96_64']} max={10} min={2} div_id={styles.canvas18}/>
                    <ElMeterCell {...this.props} ps={['ti_6_94_5']} div_id={styles.canvas42}/>
                    <Uso {...this.props} ps={['tc_6_94_0']} direction="left" caption="Эконом-04-5" div_id={styles.canvas32}/>
                    <Uso {...this.props} ps={['tc_6_94_0']} direction="left" caption="Форт-04.1" div_id={styles.canvas33}/>
                    {
                        cellData.map(function (childData, i) {

                            return <Cell {...this.props}
                                         key={'teplo' + i}
                                         onClick={this.openModal.bind(this, childData.chartPs)}
                                         ps={childData.ps}
                                         div_id={childData.div_id}
                                         caption={childData.caption}
                                         hint={childData.hint}
                                         className={childData.className}
                            />
                        }.bind(this))
                    }


                    <div className={styles.line1}></div>
                    <div className={styles.line3}></div>
                    <div className={styles.line4}></div>
                    <div className={styles.line5}></div>
                    <div className={styles.line8}></div>
                    <div className={styles.line9}></div>
                    <div className={styles.line10}></div>
                    <div className={styles.line11}></div>
                    <div className={styles.line12}></div>
                    <div className={styles.line13}></div>
                    <div className={styles.line14}></div>
                    <div className={styles.line15}></div>
                    <div className={styles.line16}></div>
                    <div className={styles.line17}></div>
                    <div className={styles.line18}></div>
                    <div className={styles.line19}></div>

                    <div className={styles.line2}></div>
                    <div className={styles.line20}></div>
                    <div className={styles.line21}></div>
                    <div className={styles.line22}></div>
                    <div className={styles.line23}></div>
                    <div className={styles.line24}></div>
                    <div className={styles.line25}></div>
                    <div className={styles.line26}></div>
                    <div className={styles.line27}></div>
                    <div className={styles.line28}></div>
                    <div className={styles.line29}></div>
                    <div className={styles.line30}></div>
                    <div className={styles.line31}></div>
                    <div className={styles.line32}></div>
                    <div className={styles.line33}></div>
                    <div className={styles.line34}></div>
                    <div className={styles.line35}></div>
                    <div className={styles.line36}></div>
                    <div className={styles.line37}></div>
                    <div className={styles.line38}></div>
                    <div className={styles.line39}></div>
                    <div className={styles.line40}></div>
                    <div className={styles.line41}></div>
                    <div className={styles.line42}></div>
                    <div className={styles.line43}></div>
                    <div className={styles.line44}></div>
                    <div className={styles.line45}></div>
                    <div className={styles.line46}></div>
                    <div className={styles.line47}></div>
                    <div className={styles.line48}></div>
                    <div className={styles.line49}></div>
                    <div className={styles.line50}></div>
                    <div className={styles.line51}></div>
                    <div className={styles.line52}></div>
                    <div className={styles.line53}></div>
                    <div className={styles.line54}></div>
                    <svg className={styles.svgRect} width="70" height="200">
                        <rect width="70" height="200"/>
                    </svg>

                    <div className={'triangleDown' + ' ' + styles.triangle1}></div>
                    <div className={'triangleUp' + ' ' + styles.triangle2}></div>
                    <div className={'triangleDown' + ' ' + styles.triangle3}></div>
                    <div className={'triangleUp' + ' ' + styles.triangle4}></div>
                    <div className={'triangleUp' + ' ' + styles.triangle5}></div>
                    <div className={'triangleDown' + ' ' + styles.triangle6}></div>
                    <div className={'triangleUp' + ' ' + styles.triangle7}></div>
                    <div className={'triangleDown' + ' ' + styles.triangle8}></div>
                    <div className={'triangleDown' + ' ' + styles.triangle10}></div>
                    <div className={'triangleUp' + ' ' + styles.triangle11}></div>
                    <div className={'triangleDown' + ' ' + styles.triangle12}></div>
                    <div className={'triangleUp' + ' ' + styles.triangle13}></div>
                    <div className={'triangleDown' + ' ' + styles.triangle14}></div>
                    <div className={'triangleUp' + ' ' + styles.triangle15}></div>
                    <div className={'triangleDown' + ' ' + styles.triangle16}></div>
                    <div className={'triangleUp' + ' ' + styles.triangle17}></div>

                    <div className={classNames('capt', styles.capt1)}>ЕК-3</div>
                    <div className={classNames('capt', styles.capt2)}>ЕК-1</div>
                    <div className={classNames('capt', styles.capt3)}>Н-3</div>
                    <div className={classNames('capt', styles.capt5)}>КП-1</div>
                    <div className={classNames('capt', styles.capt6)}>Н-1</div>
                    <div className={classNames('capt', styles.capt7)}>ТО</div>
                    <div className={classNames('capt', styles.capt8)}>КР-1</div>
                    <div className={classNames('capt', styles.capt9)}>ЕК-2</div>
                    <div className={classNames('capt', styles.capt10)}>Н-2</div>
                    <div className={classNames('capt', styles.capt11)}>Тепловая нагрузка <br/> здания</div>
                    <div className={classNames('capt', styles.capt12)}>Температура наружного воздуха</div>
                    <div className={classNames('capt', styles.capt13)}>Контур-1</div>
                    <div className={classNames('capt', styles.capt4)}>Контур-2</div>
                    <div className={classNames('capt', styles.capt14)}>Контур-3</div>
                    <div className={classNames('capt', styles.capt15)}>Температура воздуха в ИТП</div>
                    <div className={classNames('capt', styles.capt16)}>Температура в отделе заказов</div>
                   
                    {/*<div className={"col-md-offset-1 col-md-10 screenText "+styles.text}>*/}
                    {/*<p>Страница автоматизированного рабочего места (АРМ) «Тепловая» в реальном времени отображает информацию о состоянии основного технологического оборудования узла электроиндукционного нагрева автоматизированного (ВЕНА).</p>*/}
                    {/*<p>Для просмотра показателей теплового режима узла нагрева, температуры наружного воздуха или температуры в помещениях объекта за прошедший период в виде графика наведите курсор на интересующий Вас показатель и, при появлении символа <i className="fa fa-hand-pointer-o"></i>,  нажмите на левую кнопку мыши.</p>*/}
                    {/*</div>*/}
                    { (()=> {
                        return super.render();
                    })()
                    }
                </div>
                <div className={"row col-md-6"}>
                    <p>EK1 - индукционный нагреватель ТЕРЕН-100 (100кВт)<br></br>
                     EK2 - индукционный нагреватель ТЕРЕН-22 (22кВт)<br></br>
                     EK3 - индукционный нагреватель ТЕРЕН-100 (100кВт)<br></br>
                     БА - бак аккумулятор ТА-15 (полезная емкость 15м3)<br></br>
                     КР-1 - клапан трехходовой, регулирующий<br></br>
                     ТО - теплообменник пластинчатый, проточный<br></br>
                     Н-1. Насос циркуляционный контура генератора.<br></br>
                     Н-2. Насос циркуляционный контура нагрузки.</p>
                </div>
                <div className={"row col-md-6"}>
                    <p>1. Контур-1: Сигнализация низкого уровня заряда бака аккумулятора.<br></br>
                     Бак аккумулятор требует дополнительного заряда.<br></br>
                     2. Контур-2: контур управления ограничением разряда бака аккумулятора.<br></br>
                     Разрешает включение электрокотлов во время ПОЛУПИКа.<br></br>
                     3. Контур-3: контур управления клапаном регулирования КР-1.<br></br>
                     Поддержание температуры в подающем трубопроводе при автономном <br></br>
                     отоплении.</p>
                </div>

                <div className={"row col-md-12 screenText"}>
                    <p>Страница автоматизированного рабочего места (АРМ) «Гидравлическая» в реальном времени отображает
                        информацию о состоянии основного технологического оборудования узла электроиндукционного нагрева
                        автоматизированного (ВЕНА).</p>
                    <p>Для просмотра показателей в виде графика за прошедший период наведите курсор на интересующий Вас
                        показатель и, при появлении символа <i className="fa fa-hand-pointer-o"></i>, нажмите на левую
                        кнопку мыши.</p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Teplo/index.jsx